import React from "react";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  
} from "react-bootstrap"; 
import telenganafood from "../../assets/telangana-food.png";

export default function FTL() {
//    const [open, setOpen] = useState(0);
  

  return (
    <>
    <div className="bg-light py-5">
    
           <section className="bg-light">
                  <Container>
                    <Row className="g-4 align-items-start">
                      {/* LEFT CONTENT */}
                      <Col lg={8}>
                              <div>
                                  <h1>Telangana State - Food Processing and Preservation Policy (T-FAPP) 2021</h1>
                                  
                                  <h2>Food Processing and Preservation Policy are:</h2>
                                  <p>Create capacities in the state to process the additional production expected in the agriculture, horticulture, livestock, dairy, and fisheries sectors due to the significant increase in the state's irrigation potential Provide infrastructure, financial incentives and facilities for producers and producer groups / OPF / By founding food processing companies, SHGs will gradually integrate them into the value</p>
                                  <p>Create a rural industrial ecosystem by building food processing industries that will lead to more economic activity, employment, and general development of the rural / remote / backward parts of the state, business opportunities for vulnerable areas of society (women, SC / ST) promoting start-up of food processing companies across the state that enable the creation of a large local demand for state products and the export of processed products to other states and / or countries</p>
                                
                            </div>
                        </Col>
                                <Col lg={4}>
                                             <div className="p-4 shadow rounded right-form">
                                               <Form>
                                                 <Form.Control className="mb-3" placeholder="Name" />
                                                 <Form.Control className="mb-3" placeholder="Email" />
                                                 <Form.Control className="mb-3" placeholder="Phone" />
                                                 <Form.Control className="mb-3" placeholder="Subject" />
                                                 <Button className="w-100">Get Started</Button>
                                               </Form>
                                             </div>
                               </Col>
            </Row>                      
                      <Row className="g-4 align-items-start">
                          <Col lg={12} xl={12}>
                             <div>
                                <h2>The policy aims to achieve the following outcomes:</h2>
                                <p>Creation of 10,000 acres of dedicated food processing zones across the state to support an additional 53 lakh acres brought under irrigated till 2024 - 25.</p>
                                <p>Attracting a total of 15,000 crores of capital investments to start food processing businesses and create direct employment for approximately 70,000 people</p>
                                  
                                  <h2>To achieve the targets, the following action plan is proposed in the policy:</h2>
                                  <p>Creation of special food processing zones (200 to 1000 acres each) covering a total of 10,000 acres across the state, according to the increased irrigated area and diversified production profile based on the proposed statewide regulated crop pattern.</p>
                                  <p>The Dedicated special zones for the integrated meat, fish, milk, and poultry production across the state</p>
                                  <p>Providing warehousing, logistics, marketing, and export oriented designated areas for the agri-food commodities in the state</p>
                                  <p>Creation of plug-and-play sheds and associated infrastructure in the special food zones for local entrepreneurs, farmer groups, SC, ST, and minorities</p>
                                  <p>Special financial advantages for companies that are to be in special food processing zones, with additional advantages for SC, ST and minorities</p>
                                  <p>Special financial advantages for SHGs and agricultural producer organizations when setting up new food processing companies and expanding / modernizing existing food processing companies</p>
                                  <p>Tailor-made incentives for large projects in food processing and Retailers who support the largescale purchase of important government raw materials and acquire large quantities of the various medium-sized companies Food processing companies in the state in the micro franchise model</p>
                                  <p>Policy provisions:</p>

                                  <img className="img-fluid b-block mx-auto mb-3" src={telenganafood} alt="telenganafood" />

                                  <p>For more details about the T – FAPP</p>
                                  <p>How Enrich will Help You?</p>
                                  <p>Enrich services are a DGFT and Industrial Subsidies Consulting company. We can help you to get the subsidy from Telangana State Government for your special food processing zone. Like our expert team will guide you with step by step instruction to fill the all forms with perfect details for T-FAPP.</p>
                                  <p>Want to know more details about the subsidies through call, you can contact us @ 72077 57511</p>
                                
                             </div>
                              </Col>
                          </Row>
            </Container>
        </section>
        
    </div>
    </>    
  );
}